<app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplate" [modulo]="'Seguimientos ordenes'"
                  [tituloCard]="'Ordenes'" [titulo]="'Seguimientos ordenes'">
</app-lfsa-card-v2>
<ng-template #innTemplateButton>
</ng-template>
<ng-template #enviarTemplate>
  <br>
  <section class="section">
    <form [formGroup]="formulario" class="form-group" novalidate>
      <div class="row">
        <div class="col-md-4">
          <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('numCaso')" [id]="'numCaso'" [label]="'Num Orden*'"
                          [placeholder]="'Orden'" [type]="'number'" formControlName="numCaso">
          </app-lfsa-input>
        </div>
        <div class="col-md-2">
          <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('fechaInicio')" [id]="'fechaInicio'" [label]="'Fecha Inicio*'"
                          [placeholder]="'Fecha Inicio'" [type]="'date'" formControlName="fechaInicio">
          </app-lfsa-input>
        </div>
        <div class="col-md-2">
          <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('fechaFinal')" [id]="'fechaFinal'" [label]="'Fecha Fin*'"
                          [placeholder]="'Fecha'" [type]="'date'" formControlName="fechaFinal">
          </app-lfsa-input>
        </div>
        <div class="col-md-2">
          <label for=""></label><br>
          <button (click)="generarSeguimiento()" [disabled]="formulario.invalid" [tooltip]="'BUSCAR/GRAFICAR'"
                  class="btn btn-success btn-block"><i class="fa fa-search"></i></button>
        </div>
        <div class="col-md-2">
          <label for=""></label><br>
          <button (click)="abrirLink()"  [disabled]="this.urlPdf === null" [tooltip]="'EXPORTAR PDF'" class="btn btn-success btn-block" *ngIf="!listaVacia"><i
            class="fa fa-file-pdf"></i></button>
        </div>
      </div>
    </form>
    <hr>
    <div class="row" *ngIf="cabeceraSegui.codCliente !== undefined">
      <div class="col-md-4">
        <label><b>Cod. cliente:</b> {{ cabeceraSegui.codCliente }}</label>
        <label><b>Cliente:</b> {{ cabeceraSegui.nomCliente }}</label>
        <label><b>Entrega estimada en:</b> {{cabeceraSegui.direccion }} • {{ cabeceraSegui.horaEstimada }}</label>
      </div>
      <div class="col-md-2">
        <label>     </label>
        <label><b>{{ cabeceraSegui.estadoRuta }}</b></label>
        <label>{{ cabeceraSegui.esquema }}, {{ cabeceraSegui.ciudad }}</label>
      </div>
      <div class="col-md-6">
        <label><b>Esquema:</b> {{ cabeceraSegui.esquema }}</label>
        <br>
        <label><b>Dirección del Esquema:</b> {{cabeceraSegui.direccionEsquema}}</label>
      </div>
    </div>
    <hr>
    <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li class="nav-item" role="presentation">
        <button aria-controls="home" aria-selected="true" class="nav-link active" data-bs-target="#home" data-bs-toggle="tab"
                id="home-tab" role="tab" type="button">Historial y Detalle
        </button>
      </li>
      <!--<li class="nav-item" role="presentation">
        <button (click)="notInvetarioDetallado()" aria-controls="profile" aria-selected="false" class="nav-link"
                data-bs-target="#profile" data-bs-toggle="tab" id="profile-tab" role="tab"
                type="button">Inventario
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button (click)="getInvetarioDetallado()" aria-controls="contact" aria-selected="false" class="nav-link"
                data-bs-target="#contact" data-bs-toggle="tab" id="contact-tab" role="tab" type="button">
          Inventario
          Detallado
        </button>
      </li>-->
    </ul>
    <div class="tab-content" id="myTabContent">
      <div aria-labelledby="home-tab" class="tab-pane fade show active" id="home" role="tabpanel">
        <div class="row">
          <app-lfsa-alerts [listaVacia]="listaVacia" [loading]="loading"></app-lfsa-alerts>
          <div class="col-md-6">
            <div class="card" *ngIf="!listaVacia">
              <div class="card-header">
                <h5>Historial</h5>
              </div>
              <div class="card-body">
                <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" *ngIf="!listaVacia"
                               [columnDefs]="columnDefs" [floatingFilter]="false" [frameworkComponents]="frameworkComponents " [localeText]="AG_GRID_LOCALE_ES"
                               [pagination]="true" [rowData]="rowData" [rowSelection]="rowSelection" [rowHeight]=120
                               [style]="modulo.agGrid.style" class="ag-theme-alpine"
                               [paginationPageSize]="$any(modulo.agGrid).paginacion">
              </ag-grid-angular>
              </div>
            </div>
            
          </div>
          <div class="col-md-6">
            
              <div class="card" *ngIf="!listaVacia">
                <div class="card-header">
                  <h5>Detalle</h5>
                </div>
                <div class="card-body">
                  <ag-grid-angular #agGrid (gridReady)="onGridItemReady($event)" 
                               [columnDefs]="columnItemDefs" [floatingFilter]="true" [frameworkComponents]="frameworkItemsComponents " [localeText]="AG_GRID_LOCALE_ES"
                               [pagination]="true" [rowData]="rowItemsData" [rowSelection]="rowItemsSelection" [rowHeight]=100
                               [style]="modulo.agGrid.style" class="ag-theme-alpine" autoHeaderHeight=true
                               [paginationPageSize]="$any(modulo.agGrid).paginacion">
                </ag-grid-angular>
                </div>
              </div>
          </div>
        </div>
      </div>
      <!--<div aria-labelledby="profile-tab" class="tab-pane fade" id="profile" role="tabpanel">
        <section class="section">
          <div class="row">
            <div class="col-md-12 ">
              <app-lfsa-alerts [listaVacia]="listaVacia" [loading]="loading" [texto]="DAT_TITULOS.listaVacia">
              </app-lfsa-alerts>
              <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" *ngIf="!listaVacia"
                               [columnDefs]="columnDefs" [floatingFilter]="true" [frameworkComponents]="frameworkComponents " [localeText]="AG_GRID_LOCALE_ES"
                               [pagination]="true" [rowData]="rowData" [rowSelection]="rowSelection"
                               [style]="modulo.agGrid.style" class="ag-theme-alpine"
                               [paginationPageSize]="$any(modulo.agGrid).paginacion">
              </ag-grid-angular>
            </div>
          </div>
        </section>
      </div>
      <div aria-labelledby="contact-tab" class="tab-pane fade" id="contact" role="tabpanel">
        <section class="section">
          <div class="row">
            <div class="col-md-12 ">
              <app-lfsa-alerts [listaVacia]="listaVacia" [loading]="loading" [texto]="DAT_TITULOS.listaVacia">
              </app-lfsa-alerts>
              <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" *ngIf="!listaVacia"
                               [columnDefs]="columnDefs" [floatingFilter]="true" [frameworkComponents]="frameworkComponents " [localeText]="AG_GRID_LOCALE_ES"
                               [pagination]="true" [rowData]="rowData" [rowSelection]="rowSelection"
                               [style]="modulo.agGrid.style" class="ag-theme-alpine"
                               [paginationPageSize]="$any(modulo.agGrid).paginacion">
              </ag-grid-angular>
            </div>
          </div>
        </section>
      </div>-->
    </div>
  </section>
</ng-template>
